export default "__VITE_ASSET__gsoy7ok7__"